import { Text } from '@dixa/lib-shared-habla';
import { PropsWithChildren } from 'lib-shared-types-utils';

import styles from '../../searchControls.module.scss';

export const FilterDropdownTitle = ({
  children,
}: PropsWithChildren): JSX.Element => (
  <Text.Paragraph variant="3" subdued className={styles.dropdownTitle}>
    {children}
  </Text.Paragraph>
);
